__turbopack_context__.v({
  "description": "LabelWithDescription-module-scss-module__eYo3VW__description",
  "labelWithDescriptionWrapper": "LabelWithDescription-module-scss-module__eYo3VW__labelWithDescriptionWrapper",
  "title": "LabelWithDescription-module-scss-module__eYo3VW__title",
});
